import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './components/Header23';
import Footer from './components/Footer23';

const Template23TermsAndConditions = () => {
    const navigate = useNavigate();

    const sections = [
        {
            title: '1. Acceptance of Terms',
            content: `By accessing and using this website, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services. These terms apply to all visitors, customers, and users of the site.`,
        },
        {
            title: '2. Products & Services',
            content: `All products displayed on our website are subject to availability. We make every effort to display accurate images and descriptions of our products, including color, fabric details, and embroidery patterns. However, due to the handcrafted nature of our festive and bridal wear, slight variations in color, pattern, and finish may occur. These variations are a hallmark of artisan craftsmanship and are not considered defects.`,
        },
        {
            title: '3. Pricing & Payment',
            content: `All prices are displayed in Indian Rupees (INR) and are inclusive of applicable taxes unless stated otherwise. We reserve the right to modify prices at any time without prior notice. Payment can be made via credit/debit cards, UPI, net banking, or cash on delivery (where available). All transactions are processed through secure, encrypted payment gateways.`,
        },
        {
            title: '4. Custom Orders & Bridal Wear',
            content: `Custom-sized and made-to-order pieces are non-refundable and non-exchangeable unless there is a manufacturing defect. Custom orders require a 50% advance payment at the time of order confirmation. Production timelines for custom bridal wear range from 4-8 weeks depending on the complexity of the design. Customers are responsible for providing accurate measurements as per our size guide.`,
        },
        {
            title: '5. Order Cancellation',
            content: `Orders for ready-to-ship products can be cancelled within 12 hours of placing the order. Custom orders cannot be cancelled once production has begun. To request a cancellation, please contact our customer support via WhatsApp or email with your order ID.`,
        },
        {
            title: '6. Shipping & Delivery',
            content: `We offer nationwide shipping across India and international shipping to select countries. Standard delivery takes 7-10 business days within India. Express delivery options are available for time-sensitive orders (e.g., wedding dates). We are not responsible for delays caused by customs, natural disasters, or other events beyond our control. All shipments include tracking information sent via email and SMS.`,
        },
        {
            title: '7. Returns & Exchanges',
            content: `Ready-to-ship products may be returned or exchanged within 7 days of delivery, provided they are unused, unwashed, and in their original packaging with all tags intact. Custom-made, altered, or bridal pieces are final sale. Return shipping costs are borne by the customer unless the return is due to a defect or error on our part. Refunds are processed within 7-10 business days after the returned item is inspected and approved.`,
        },
        {
            title: '8. Intellectual Property',
            content: `All content on this website, including but not limited to text, images, designs, logos, product images, and brand elements, is the intellectual property of UTSAV and is protected under applicable copyright and trademark laws. Unauthorized reproduction, distribution, or use of any content is strictly prohibited.`,
        },
        {
            title: '9. User Account',
            content: `When you create an account with us, you are responsible for maintaining the confidentiality of your account credentials. You agree to accept responsibility for all activities that occur under your account. We reserve the right to terminate accounts that violate these terms or engage in fraudulent activity.`,
        },
        {
            title: '10. Limitation of Liability',
            content: `To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our website or products. Our total liability for any claim shall not exceed the amount paid by you for the specific product or service giving rise to the claim.`,
        },
        {
            title: '11. Governing Law',
            content: `These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising from these terms or the use of our services shall be subject to the exclusive jurisdiction of the courts in Jaipur, Rajasthan.`,
        },
        {
            title: '12. Changes to Terms',
            content: `We reserve the right to update or modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on the website. Your continued use of the website constitutes acceptance of the modified terms. We encourage you to review these terms periodically.`,
        },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Nunito+Sans:wght@300;400;500;600;700&display=swap');
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FFFDF8' }}>
                <Header cartCount={0} />

                {/* Hero */}
                <div style={{
                    background: 'linear-gradient(135deg, #1B3A2D 0%, #2D5A45 100%)',
                    textAlign: 'center',
                    padding: '130px 24px 60px',
                }}>
                    <h1 style={{
                        fontFamily: "'Libre Baskerville', Georgia, serif",
                        fontSize: 'clamp(28px, 4vw, 42px)',
                        fontWeight: 700,
                        color: '#FFFFFF',
                        margin: '0 0 12px 0',
                    }}>
                        Terms & Conditions
                    </h1>
                    <p style={{
                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                        fontSize: '15px',
                        color: 'rgba(255,255,255,0.7)',
                        margin: 0,
                    }}>
                        Last updated: March 19, 2026
                    </p>
                </div>

                {/* Content */}
                <div style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    padding: '60px 24px 80px',
                }}>
                    <p style={{
                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                        fontSize: '15px',
                        color: '#5A5A5A',
                        lineHeight: 1.7,
                        margin: '0 0 40px 0',
                    }}>
                        Welcome to UTSAV. Please read these Terms and Conditions carefully before using our website
                        or purchasing our products. By placing an order or using our services, you agree to comply
                        with and be bound by the following terms.
                    </p>

                    {sections.map((section, idx) => (
                        <div key={idx} style={{ marginBottom: '36px' }}>
                            <h2 style={{
                                fontFamily: "'Libre Baskerville', Georgia, serif",
                                fontSize: '20px',
                                fontWeight: 700,
                                color: '#1B3A2D',
                                margin: '0 0 12px 0',
                            }}>
                                {section.title}
                            </h2>
                            <p style={{
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '15px',
                                color: '#5A5A5A',
                                lineHeight: 1.8,
                                margin: 0,
                            }}>
                                {section.content}
                            </p>
                        </div>
                    ))}

                    {/* Contact */}
                    <div style={{
                        backgroundColor: '#F8F3EC',
                        borderRadius: '14px',
                        padding: '28px',
                        marginTop: '48px',
                    }}>
                        <h3 style={{
                            fontFamily: "'Libre Baskerville', Georgia, serif",
                            fontSize: '18px',
                            fontWeight: 700,
                            color: '#1B3A2D',
                            margin: '0 0 12px 0',
                        }}>
                            Questions About Our Terms?
                        </h3>
                        <p style={{
                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                            fontSize: '14px',
                            color: '#5A5A5A',
                            lineHeight: 1.6,
                            margin: '0 0 16px 0',
                        }}>
                            If you have any questions regarding these terms, please do not hesitate to contact us.
                        </p>
                        <button
                            onClick={() => navigate('/template23/contact')}
                            style={{
                                padding: '10px 24px',
                                backgroundColor: '#1B3A2D',
                                color: '#FFFFFF',
                                border: 'none',
                                borderRadius: '8px',
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '13px',
                                fontWeight: 700,
                                cursor: 'pointer',
                            }}
                        >
                            Contact Us
                        </button>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Template23TermsAndConditions;
